import { FC, ReactNode } from 'react';
import styles from './PunchupFeedItem.module.css';

export interface PunchupFeedItemProps {
	icon?: ReactNode;
	label?: string;
	timestamp?: string;
	/** Secondary descriptive content rendered below the header row. */
	children?: ReactNode;
	/** Optional row of action buttons rendered at the bottom-right. */
	actions?: ReactNode;
}

export const PunchupFeedItem: FC<PunchupFeedItemProps> = ({ icon, label, timestamp, children, actions }) => {
	const hasHeader = !!(icon || label || timestamp);
	return (
		<div className={styles.root}>
			{hasHeader && (
				<div className={styles.header}>
					{icon && <span className={styles.icon}>{icon}</span>}
					{label && <span className={styles.label}>{label}</span>}
					{timestamp && <span className={styles.timestamp}>{timestamp}</span>}
				</div>
			)}
			{children && <div className={styles.details}>{children}</div>}
			{actions && <div className={styles.actions}>{actions}</div>}
		</div>
	);
};
